import {
  NOVITA_EMBED_ALLOWED_ORIGINS,
  NOVITA_EMBED_CHAT_MESSAGE_SOURCE,
  NOVITA_EMBED_CHAT_MESSAGE_TYPE,
  NOVITA_EMBED_GO_BACK_MESSAGE_TYPE,
  NOVITA_EMBED_MARK_ALL_READ_MESSAGE_TYPE,
  NOVITA_EMBED_OPEN_URL_MESSAGE_TYPE,
  NOVITA_EMBED_URL,
  NOVITA_EMBED_VIEWED_MESSAGE_TYPE,
} from './config';

const isObjectRecord = (value) =>
  Boolean(value) && typeof value === 'object' && !Array.isArray(value);

const readString = (value) =>
  typeof value === 'string' && value.trim() ? value.trim() : null;

const readStringArray = (value) => {
  if (!Array.isArray(value)) return [];

  return value.map(readString).filter(Boolean);
};

const isAllowedNovitaEmbedOrigin = (origin) =>
  typeof origin === 'string' && NOVITA_EMBED_ALLOWED_ORIGINS.includes(origin);

export const normalizeNovitaEmbedNavigationUrl = (value) => {
  const stringValue = readString(value);
  if (!stringValue) return null;

  try {
    const parsedUrl = new URL(stringValue);
    return parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:'
      ? parsedUrl.href
      : null;
  } catch {
    return null;
  }
};

export const buildNovitaItemEmbedUrl = (value) => {
  const normalized = normalizeNovitaEmbedNavigationUrl(value);
  if (!normalized) return null;

  const trimmed = normalized.replace(/\/+$/, '');
  return trimmed.endsWith('/embed') ? trimmed : `${trimmed}/embed`;
};

export const buildNovitaListEmbedUrl = (unreadIds = []) => {
  const ids = unreadIds.filter(Boolean);
  if (!ids.length) return NOVITA_EMBED_URL;

  const url = new URL(NOVITA_EMBED_URL);
  url.searchParams.set('unread', ids.join(','));
  return url.toString();
};

export const parseNovitaEmbedMessage = (event, expectedSource) => {
  if (expectedSource && event?.source !== expectedSource) {
    return null;
  }

  if (!isAllowedNovitaEmbedOrigin(event?.origin)) {
    return null;
  }

  if (!isObjectRecord(event?.data)) {
    return null;
  }

  const data = event.data;
  if (data.source !== NOVITA_EMBED_CHAT_MESSAGE_SOURCE) {
    return null;
  }

  switch (data.type) {
    case NOVITA_EMBED_CHAT_MESSAGE_TYPE:
      return { type: NOVITA_EMBED_CHAT_MESSAGE_TYPE };

    case NOVITA_EMBED_OPEN_URL_MESSAGE_TYPE: {
      const url = readString(data.url) || readString(data.href);
      return url ? { type: NOVITA_EMBED_OPEN_URL_MESSAGE_TYPE, url } : null;
    }

    case NOVITA_EMBED_GO_BACK_MESSAGE_TYPE:
      return {
        type: NOVITA_EMBED_GO_BACK_MESSAGE_TYPE,
        fallbackUrl: readString(data.fallbackUrl),
      };

    case NOVITA_EMBED_VIEWED_MESSAGE_TYPE: {
      const id = readString(data.id);
      const slug = readString(data.slug);
      const publishedAt = readString(data.publishedAt);
      if (!id || !slug || !publishedAt) return null;

      return {
        type: NOVITA_EMBED_VIEWED_MESSAGE_TYPE,
        id,
        slug,
        publishedAt,
        path: readString(data.path),
        url: readString(data.url),
      };
    }

    case NOVITA_EMBED_MARK_ALL_READ_MESSAGE_TYPE: {
      const ids = readStringArray(data.ids);
      if (!ids.length) return null;

      return {
        type: NOVITA_EMBED_MARK_ALL_READ_MESSAGE_TYPE,
        ids,
        path: readString(data.path),
        url: readString(data.url),
      };
    }

    default:
      return null;
  }
};
